import {
  Box,
  Typography,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import color from "../../components/utils/Colors";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";
import CourseCardWishlist from "../../components/cards/CourseCardWishlist";
import {
  getDataFromTable,
  getUserWishlist,
  removeFromWishlist,
} from "../../services/services";
import { useUser } from "../../services/Context/UserContext";
import { useSnackbar } from "../../components/utils/SnackBar";

const Wishlist: React.FC = () => {
  const { user } = useUser();
  const showSnackbar = useSnackbar();
  const [wishlistItems, setWishlistItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const isSmallScreen = useMediaQuery("(max-width:900px)");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (user?.id) {
      setLoading(true);

      getUserWishlist(user.id)
        .then(async (res: any) => {
          const wishlist = res?.data?.data || [];

          const wishlistWithCourse = await Promise.all(
            wishlist.map(async (item: any) => {
              const courseRes = await getDataFromTable("course", {
                id: item.courseId,
              });

              return {
                ...item,
                course: courseRes?.data?.data?.[0],
              };
            }),
          );

          console.log("Wishlist with course:", wishlistWithCourse);
          setWishlistItems(wishlistWithCourse);
        })
        .catch((err: any) => {
          console.error("Failed to fetch wishlist", err);
          showSnackbar("Failed to load wishlist");
        })
        .finally(() => setLoading(false));
    }
  }, [user?.id, reload]);

  const handleRemove = (id: number) => {
    removeFromWishlist(id)
      .then(() => {
        showSnackbar("Removed from wishlist");
        setReload((prev) => !prev);
      })
      .catch((err: any) => {
        console.error("Failed to remove from wishlist", err);
        showSnackbar("Failed to remove item");
      });
  };

  return (
    <div style={{ minHeight: "90vh", paddingBottom: "40px" }}>
      <Typography
        onClick={handleGoBack}
        sx={{
          margin: 0,
          position: "absolute",
          top: isSmallScreen ? "120px" : "150px",
          color: color.firstColor,
          fontSize: "16px",
          fontWeight: "bold",
          paddingLeft: isSmallScreen ? 5 : 10,
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <ChevronLeft></ChevronLeft> Back
      </Typography>

      <Typography
        variant="h5"
        align="center"
        sx={{
          background: color.textColor,
          textAlign: "center",
          color: "white",
          width: "fit-content",
          margin: "auto",
          padding: "4px 16px",
          borderRadius: "4px",
          mb: 4,
          mt: 4,
        }}
      >
        Wishlist
      </Typography>

      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress sx={{ color: color.firstColor }} />
        </Box>
      )}

      {!loading && wishlistItems.length === 0 && (
        <Typography
          sx={{ textAlign: "center", color: "gray", mt: 10, fontSize: "18px" }}
        >
          Your wishlist is empty.
        </Typography>
      )}

      {!loading &&
        wishlistItems.map((item: any, index: number) => (
          <Box
            key={item.id ?? index}
            p={4}
            pl={6}
            pr={6}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CourseCardWishlist
              courseName={
                item?.course?.title ?? item?.course?.courseName ?? "Course"
              }
              teachers={
                item?.course?.teachersName
                  ? [item.course.teachersName]
                  : (item?.course?.teachers ?? [])
              }
              localRating={item?.course?.localRating ?? 0}
              globalRating={item?.course?.globalRating ?? 0}
              price={item?.course?.price ?? 0}
              level={item?.course?.level ?? ""}
              duration={item?.course?.timeline ?? item?.course?.duration ?? ""}
              image={
                item?.course?.image ??
                item?.course?.coverImage ??
                "/assets/Course 1.png"
              }
              onRemove={() => handleRemove(item.id)}
              courseId={item?.course?.id}
              unitOfPrice={item?.course?.unitOfPrice}
            />
          </Box>
        ))}
    </div>
  );
};

export default Wishlist;
